/**
 * Builds the explore app's category product-list URL, e.g.
 * https://app.bxiworld.com/home/marketplaceproductlist?marketplaceCategory=QSR&productCategory=63e38bd5cc4c02b8a0c94b87
 *
 * `productCategory` is the company-type ObjectId (stable, seeded) for each
 * marketplace category. Keys are the canonical category display names used by
 * the landing-page category tiles.
 */
import { getDashboardUrl } from './navigation';

const EXPLORE_PRODUCT_LIST_PATH = '/home/marketplaceproductlist';

export const CATEGORY_PRODUCT_IDS = {
  Textile: '63e38b96cc4c02b8a0c94b6c',
  Lifestyle: '63e38b9ccc4c02b8a0c94b6f',
  Media: '63e38b91cc4c02b8a0c94b69',
  'Office Supply': '63e38bc6cc4c02b8a0c94b81',
  Electronics: '63e38bcecc4c02b8a0c94b84',
  Hotel: '63e38ba3cc4c02b8a0c94b72',
  QSR: '63e38bd5cc4c02b8a0c94b87',
  'Airline Tickets': '63e38bbfcc4c02b8a0c94b7e',
  'Entertainment & Events': '64218b189fe1b6ae750c11bd',
  FMCG: '63e38bb9cc4c02b8a0c94b7b',
  Mobility: '63e38bb3cc4c02b8a0c94b78',
  Others: '63e38bddcc4c02b8a0c94b8a',
};

/** Legacy landing paths -> canonical marketplace category name. */
export const LEGACY_CATEGORY_PATH_TO_NAME = {
  'textile-industry': 'Textile',
  'lifestyle-products': 'Lifestyle',
  lifestyle: 'Lifestyle',
  'media-solutions': 'Media',
  'office-supplies': 'Office Supply',
  electronics: 'Electronics',
  hotels: 'Hotel',
  hotel: 'Hotel',
  'qsr-restaurant': 'QSR',
  'qsr-restaurants': 'QSR',
  'airline-tickets': 'Airline Tickets',
  'entertainment-events': 'Entertainment & Events',
  'fmcg-products': 'FMCG',
  'mobility-solutions': 'Mobility',
  'other-services': 'Others',
};

/** Full URL to the explore product list for a category display name. */
export function getCategoryProductListUrl(categoryName) {
  if (!categoryName) return getDashboardUrl('/explore');
  const params = new URLSearchParams();
  params.set('marketplaceCategory', categoryName);
  const productCategoryId = CATEGORY_PRODUCT_IDS[categoryName];
  if (productCategoryId) params.set('productCategory', productCategoryId);
  return `${getDashboardUrl(EXPLORE_PRODUCT_LIST_PATH)}?${params.toString()}`;
}

/** Landing marketplace path for a legacy category URL (e.g. /textile-industry → /marketplace). */
export function getLegacyCategoryRedirectUrl(legacyPath) {
  const key = String(legacyPath || '').replace(/^\//, '');
  return LEGACY_CATEGORY_PATH_TO_NAME[key] ? '/marketplace' : getDashboardUrl('/explore');
}

/** `{ from, to }` redirect rows for all legacy category paths → /marketplace. */
export function buildLegacyCategoryRedirects() {
  return Object.keys(LEGACY_CATEGORY_PATH_TO_NAME).map(path => ({
    from: `/${path}`,
    to: '/marketplace',
  }));
}
